import { CircularProgress, Modal } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Colors from "../../../constants/Colors";
import { SchedulingService } from "../../../core/http/service/SchedulingService";
import { Paths } from "../../../enums/Paths";
import useResponsiveInfo from "../../../hooks/useResponsiveInfo";
import { Button } from "../../../pages/company/companyRegister/CompanyRegister.styled";
import ErrorArea from "../../error/ErrorArea";
import { ModalContainer } from "../../genericModal/GenericModal.styled";
import { H1 } from "../../UI/generalLayout/Layout.styled";
import {
  DetailScheduleModalButtonsContainer,
  DetailScheduleUnmarkModalContainer,
  DetailScheduleUnmarkModalContent,
} from "./DetailScheduleUnmark.styled";
import { ReactComponent as Exclamation } from '../../../assets/imgs/exclamation.svg';

export interface DetailScheduleUnmarkProps {
  id: string;
  onCancelModal: () => void;
  modalOpen?: boolean;
}

const DetailScheduleUnmark: React.FC<DetailScheduleUnmarkProps> = ({
  id,
  onCancelModal,
  modalOpen = false,
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any[]>([]);
  const navigate = useNavigate();
  const { isMobile } = useResponsiveInfo();

  const onUnmarkConsult = () => {
    setLoading(true);
    const service = new SchedulingService();
    service
      .postInactiveByID(id)
      .then(() => navigate(Paths.CollaboratorInitial))
      .catch((e) => {
        setError([e]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal open={modalOpen}>
      <ModalContainer isMobile={isMobile}>
        <DetailScheduleUnmarkModalContainer>
          <DetailScheduleUnmarkModalContent>
            <Exclamation />
            <H1>Tem certeza que seja desmarcar a consulta?</H1>
          </DetailScheduleUnmarkModalContent>

          <DetailScheduleModalButtonsContainer>
            <Button
              onClick={onCancelModal}
              color={Colors.error}
              backgroundColor={Colors.WHITE}
              borderColor={Colors.error}
            >
              Voltar
            </Button>
            <Button
              disabled={loading}
              onClick={onUnmarkConsult}
              color={Colors.WHITE}
              backgroundColor={Colors.SPM600}
            >
              {loading ? <CircularProgress /> : "Confirmar"}
            </Button>
          </DetailScheduleModalButtonsContainer>
        </DetailScheduleUnmarkModalContainer>
        <ErrorArea
          errorList={error}
          onCloseAction={() => {
            setError([]);
          }}
        />
      </ModalContainer>
    </Modal>
  );
};

export default DetailScheduleUnmark;
